import { useMemo, useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { Checkbox } from '../../../../../DutyAssign/components/Attendance/Setting';
import { Alert } from '../../../../../../components';
import { i18n } from '../../../../../../language';
import { useEnableServiceOrder } from '../../../../../../utils/hooks';
import WardCodeMapping from './WardCodeMapping';
import ServicesMapping from './ServicesMapping';
import ServiceOrderRemark from './ServiceOrderRemark';

const useStyle = makeStyles(() => ({
  root: {
    borderRadius: '0 0.937rem 0.937rem',
    backgroundColor: '#ffffff',
    padding: '1.875rem 1.875rem 0',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 4.375rem - 4.5rem - 1.438rem - 3.875rem - 1.875rem)',
  },
  tabBox: {
    display: 'flex',
    paddingBottom: '1.875rem',
    borderBottom: 'solid 0.063rem #d9d9d9',
    width: '100%',
    gap: '1.25rem',
    marginBottom: '1.875rem',
  },
  tabSelected: {
    borderRadius: '20px',
    height: '2.625rem',
    backgroundColor: '#538fff',
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    color: '#ffffff',
    padding: '0 2rem',
  },
  tabUnSelected: {
    borderRadius: '20px',
    height: '2.625rem',
    backgroundColor: '#f5faff',
    fontSize: '1rem',
    color: '#c0c6cb',
    border: 'solid 1px #c0c6cb',
    padding: '0 2rem',
  },
  enableOrderServiceBtn: {
    color: '#2E4469',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Medium',
  },
}));

const ServiceOrder = () => {
  const classes = useStyle();
  const [selectedTab, setSelectedTab] = useState(1);
  const [successAlert, setSuccessAlert] = useState(false);
  const { enableOrderService, showOrderServiceBtn, updateWardCleansingEnable } = useEnableServiceOrder();

  const tabList = useMemo(
    () => [
      {
        value: 1,
        title: 'Ward Code Mapping',
        component: WardCodeMapping,
      },
      {
        value: 2,
        title: 'Services Mapping',
        component: ServicesMapping,
      },
      {
        value: 3,
        title: 'Service Order Remark',
        component: ServiceOrderRemark,
      },
    ],
    []
  );

  const SelectedComponent = tabList.find((tab) => tab.value === selectedTab)?.component;

  const handleSuccess = () => {
    setSuccessAlert(true);
  };

  return (
    <div className={classes.root}>
      <Box
        display="flex"
        bgcolor="#F1F5FB"
        minHeight="4rem"
        borderRadius="0.5rem"
        mb="1.88rem"
        pl="1.87rem"
        alignItems="center"
      >
        <ButtonBase
          className={classes.enableOrderServiceBtn}
          onClick={() => updateWardCleansingEnable('enableYn', !enableOrderService)}
        >
          <Box bgcolor="#fff" mr="0.62rem">
            <Checkbox check={enableOrderService} />
          </Box>
          Enable Order Service
        </ButtonBase>
      </Box>
      <Box className={classes.tabBox}>
        {tabList.map((tab) => (
          <ButtonBase
            key={tab.value}
            className={tab.value === selectedTab ? classes.tabSelected : classes.tabUnSelected}
            onClick={() => setSelectedTab(tab.value)}
          >
            {tab.title}
          </ButtonBase>
        ))}
      </Box>
      <SelectedComponent
        enableOrderService={enableOrderService}
        showOrderServiceBtn={showOrderServiceBtn}
        updateWardCleansingEnable={updateWardCleansingEnable}
        handleSuccess={handleSuccess}
      />
      {/* alert */}
      <Alert
        open={successAlert}
        id="DutyAssign-Alert-aib"
        onClose={() => setSuccessAlert(false)}
        text={i18n.t('DUTYASSIGN_SAVE_SUCCESS_ALERT')}
        type="success"
      />
    </div>
  );
};

export default ServiceOrder;
